import { useState } from "react";
import { supabase } from "../supabaseClient";

const NICKNAME_RE = /^[가-힣a-zA-Z0-9]+$/;

export default function NicknameModal({ userId, onSaved }) {
  const [nickname, setNickname]       = useState("");
  const [checking, setChecking]       = useState(false);
  const [dupChecked, setDupChecked]   = useState(false);
  const [dupOk, setDupOk]             = useState(false);
  const [saving, setSaving]           = useState(false);
  const [error, setError]             = useState("");

  const trimmed = nickname.trim();
  const valid = trimmed.length >= 2 && trimmed.length <= 10 && NICKNAME_RE.test(trimmed);

  const handleChange = (e) => {
    setNickname(e.target.value);
    setDupChecked(false);
    setDupOk(false);
    setError("");
  };

  const checkDuplicate = async () => {
    if (!valid) {
      setError("2~10자, 한글/영문/숫자만 사용할 수 있어요.");
      return;
    }
    setChecking(true);
    setError("");
    const { data, error: qErr } = await supabase
      .from("profiles")
      .select("user_id")
      .eq("nickname", trimmed)
      .neq("user_id", userId)
      .limit(1);

    setChecking(false);
    setDupChecked(true);

    if (qErr) {
      setError("중복 확인 중 오류가 발생했어요.");
      return;
    }
    if (data && data.length > 0) {
      setDupOk(false);
      setError("이미 사용 중인 닉네임이에요.");
    } else {
      setDupOk(true);
    }
  };

  const handleSave = async () => {
    if (!dupOk) return;
    setSaving(true);
    setError("");

    const { error: upsertErr } = await supabase
      .from("profiles")
      .upsert({ user_id: userId, nickname: trimmed }, { onConflict: "user_id" });

    setSaving(false);
    if (upsertErr) {
      setError("저장 중 오류가 발생했어요: " + upsertErr.message);
      return;
    }
    onSaved(trimmed);
  };

  const canSave = dupChecked && dupOk && !saving;

  return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <h2 style={s.title}>닉네임 설정</h2>
        <p style={s.desc}>서비스 이용을 위해 닉네임을 설정해주세요.</p>

        <input
          style={s.input}
          type="text"
          placeholder="2~10자 한글/영문/숫자"
          value={nickname}
          onChange={handleChange}
          maxLength={10}
        />
        <button
          style={{ ...s.checkBtn, opacity: valid && !checking ? 1 : 0.5 }}
          onClick={checkDuplicate}
          disabled={!valid || checking}
        >
          {checking ? "확인 중..." : "중복확인"}
        </button>

        {error && <p style={s.error}>{error}</p>}
        {dupChecked && dupOk && <p style={s.ok}>사용 가능한 닉네임이에요!</p>}

        <button
          style={{ ...s.saveBtn, opacity: canSave ? 1 : 0.5 }}
          onClick={handleSave}
          disabled={!canSave}
        >
          {saving ? "저장 중..." : "저장"}
        </button>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 10000,
    padding: 20,
  },
  modal: {
    width: 320, maxWidth: "calc(100vw - 40px)",
    background: "#fff", borderRadius: 16,
    padding: 24,
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    boxSizing: "border-box",
  },
  title: {
    margin: 0, fontSize: 20, fontWeight: 800, color: "#111827",
    textAlign: "center",
  },
  desc: {
    margin: "8px 0 20px", fontSize: 13, color: "#6b7280",
    textAlign: "center", lineHeight: 1.5,
  },
  input: {
    width: "100%", padding: "12px 14px",
    border: "1.5px solid #e5e7eb", borderRadius: 10,
    fontSize: 15, color: "#111827", outline: "none",
    fontFamily: "inherit", boxSizing: "border-box",
  },
  checkBtn: {
    width: "100%", padding: "12px 14px", marginTop: 10,
    background: "#fff", border: "1.5px solid #E24B4A",
    borderRadius: 10, fontSize: 13, fontWeight: 700,
    color: "#E24B4A", cursor: "pointer", fontFamily: "inherit",
    boxSizing: "border-box",
  },
  error: {
    margin: "10px 0 0", fontSize: 13, color: "#dc2626", lineHeight: 1.4,
  },
  ok: {
    margin: "10px 0 0", fontSize: 13, color: "#16a34a", fontWeight: 600,
    lineHeight: 1.4,
  },
  saveBtn: {
    width: "100%", padding: "14px",
    background: "#E24B4A", color: "#fff", border: "none",
    borderRadius: 12, fontSize: 16, fontWeight: 700,
    cursor: "pointer", marginTop: 20, fontFamily: "inherit",
  },
};
